(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gourmend-marquee"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-section-type="gourmend-marquee"]').forEach(function (root) {
    var btn = root.querySelector('[data-marquee-pause]');
    if (!btn) return;
    var label = btn.querySelector('.visually-hidden');
    function setPaused(paused) {
      root.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      if (label) label.textContent = paused ? 'Resume scrolling text' : 'Pause scrolling text';
    }
    btn.addEventListener('click', function () { setPaused(!root.classList.contains('is-paused')); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gourmend-pdp-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="gourmend-pdp-buybox"]').forEach(function (root) {
      var form = root.querySelector('[data-buy-form]');
      if (!form) return;
      var variantInput = root.querySelector('[data-variant-input]');
      // The pack the page opened on (Liquid `selected`). The select is PINNED to this; see the markup note.
      var pinnedVariantId = variantInput ? variantInput.value : '';
      var chosenVariantId = pinnedVariantId;
      // Gallery: the hero is an <img>; a VIDEO thumbnail swaps in a player (see showGalleryVideo). Anything that sets the
      // hero image (pack change, image thumbnail) must call showGalleryImage() first so a playing video is stopped and removed.
      var galleryImgEl = root.querySelector('[data-gallery-main]');
      var galleryVideoEl = root.querySelector('[data-gallery-video]');
      function showGalleryImage() {
        if (!galleryVideoEl || galleryVideoEl.hidden) return;
        galleryVideoEl.innerHTML = '';          // removing the node stops playback
        galleryVideoEl.hidden = true;
        if (galleryImgEl) galleryImgEl.hidden = false;
      }
      function showGalleryVideo(index, label) {
        var tpl = root.querySelector('[data-video-tpl="' + index + '"]');
        if (!tpl || !galleryVideoEl || !galleryImgEl) return false;
        galleryVideoEl.style.height = Math.round(galleryImgEl.getBoundingClientRect().height) + 'px';   // hold the hero's box: no layout jump
        // replace: galleryVideoEl.innerHTML = tpl.innerHTML;
        galleryVideoEl.innerHTML = "";
        galleryVideoEl.appendChild(tpl.content.cloneNode(true));
        var player = galleryVideoEl.querySelector("video");
        if (player) {
          player.preload = "auto";
          player.load();
          var p = player.play();
          if (p && p.catch) p.catch(function () { player.controls = true; });
        }
        var media = galleryVideoEl.querySelector('video, iframe');
        if (media) { media.setAttribute('aria-label', label || 'Product video'); media.setAttribute('title', label || 'Product video'); }
        galleryImgEl.hidden = true;
        galleryVideoEl.hidden = false;
        // Start playing: this runs inside the viewer's own click on the thumbnail, so it is a requested play, not an autoplay
        // (WCAG 2.2.2 is about content that moves on its own). Native controls stay on so it can be paused.
        var player = galleryVideoEl.querySelector('video');
        if (player) { var started = player.play(); if (started && started.catch) started.catch(function () { /* blocked: the viewer can press play */ }); }
        return true;
      }
      var addLabel = root.querySelector('[data-add-label]');
      var addPrice = root.querySelector('[data-add-price]');
      var addBtn = root.querySelector('[data-add-btn]');
      var oneTimeDisplay = root.querySelector('[data-onetime-display]');
      var subDisplay = root.querySelector('[data-sub-display]');
      var subCompare = root.querySelector('[data-sub-compare]');
      var sizes = Array.prototype.slice.call(root.querySelectorAll('[data-size]'));
      var purchase = root.querySelector('[data-purchase]');
      var modeOpts = Array.prototype.slice.call(root.querySelectorAll('[data-mode]'));
      var mode = 'onetime';

      // Sticky bar (comp band #16) — mirrors this section's state.
      var sticky = root.querySelector('[data-sticky]');
      var stickyPack = root.querySelector('[data-sticky-pack]');
      var stickyMode = root.querySelector('[data-sticky-mode]');
      var stickyLabel = root.querySelector('[data-sticky-label]');
      var stickyPrice = root.querySelector('[data-sticky-price]');
      var stickyBtn = root.querySelector('[data-sticky-btn]');
      var subBadge = root.querySelector('.gmpdp-purchase__badge');
      // Single-unit product (spice/salt/powder): the size field is hidden, so the
      // CTAs must not announce a pack count. Liquid renders the same wording; this
      // keeps refresh() from writing "Add 1-pack to cart" back over it.
      var isSingle = root.hasAttribute('data-single-variant');
      // Sold-out wording comes from the section setting so Liquid and JS can never disagree
      // about it — refresh() would otherwise write "Add 6-pack to cart" back over a server
      // rendered "Sold out" the moment someone picked a different pack.
      var soldOutLabel = root.getAttribute('data-soldout-label') || 'Sold out';
      var addArrow = root.querySelector('[data-add-arrow]');
      var stickyArrow = root.querySelector('[data-sticky-arrow]');
      var soldNote = root.querySelector('[data-soldout-note]');
      function addLabelFor(count) {
        return isSingle ? 'Add to cart' : 'Add ' + count + '-pack to cart';
      }

      function selectedSize() {
        return root.querySelector('.gmpdp-size--selected') || sizes[0];
      }

      function currentMode() {
        var sub = root.querySelector('[data-mode="subscribe"]');
        return (mode === 'subscribe' && sub) ? 'subscribe' : 'onetime';
      }

      // Seal Subscriptions injects its own widget (hidden via CSS) and OWNS the selling_plan
      // input. We flip its hidden radios so a native form submit carries the plan. The plan id is
      // product-level (same across variants), so this only needs to run on mode change.
      function applySealMode(m) {
        var seal = form.querySelector('.sealsubs-target-element');
        if (!seal) return; // Seal not loaded yet, or product has no plan
        var radios = Array.prototype.slice.call(seal.querySelectorAll('input[type="radio"]'));
        if (!radios.length) return;
        var target = radios.filter(function (r) {
          return m === 'subscribe' ? r.value !== 'one_time' : r.value === 'one_time';
        })[0];
        if (!target) return;
        target.checked = true;
        try { target.click(); } catch (e) {}
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // ---- SELLING PLAN SAFETY NET (added 2026-07-29) ---------------------
      // ⚠️ Seal does NOT always inject its widget into this form. Measured on the
      // dev server: Seal's three scripts were loaded, our Subscribe option was
      // selected, and yet there was no `.sealsubs-target-element` and no
      // `selling_plan` input anywhere in the form — the serialized body was
      // `id=…&quantity=1&pack=…&purchase_mode=subscribe`. A subscribe add-to-cart
      // therefore went in as a ONE-TIME purchase at full price. Silent revenue bug.
      //
      // HOMEPAGE-BUILD previously said "do NOT reintroduce our own selling_plan
      // input — Seal deletes it." That still holds WHEN SEAL IS THERE, so this only
      // supplies one when Seal has provided nothing:
      //   Seal widget present  → Seal owns `selling_plan`; we add nothing.
      //   Seal widget absent   → we add our own hidden input from `data-plan-id`.
      // Never both, so the cart can't receive a duplicate parameter.
      //
      // The plan id is product-level (same across variants), so one value covers
      // every pack size.
      function syncSellingPlan(m) {
        var ours = form.querySelector('[data-gm-selling-plan]');
        var sealOwns = !!form.querySelector('.sealsubs-target-element input[name="selling_plan"]');
        var subOpt = root.querySelector('[data-mode="subscribe"]');
        var planId = subOpt ? subOpt.getAttribute('data-plan-id') : '';

        if (m !== 'subscribe' || sealOwns || !planId) {
          if (ours) ours.parentNode.removeChild(ours);
          return;
        }
        if (!ours) {
          ours = document.createElement('input');
          ours.type = 'hidden';
          ours.name = 'selling_plan';
          ours.setAttribute('data-gm-selling-plan', '');
          form.appendChild(ours);
        }
        ours.value = planId;
      }

      function refresh() {
        var size = selectedSize();
        if (!size) return;
        var count = size.getAttribute('data-count');
        var oneTime = size.getAttribute('data-onetime-money');
        var sub = size.getAttribute('data-sub-money');
        var available = size.getAttribute('data-available') === 'true';

        // update purchase box prices for this size
        if (oneTimeDisplay) oneTimeDisplay.textContent = oneTime;
        if (subDisplay && sub) subDisplay.textContent = sub;
        if (subCompare) subCompare.textContent = oneTime;

        // variant id — remembered here, written to the hidden <select name="id"> ONLY at submit
        // (see the markup note: Elevar polls that select for dl_view_item, so it must not move on a
        // pack click, but it reads it on submit for dl_add_to_cart, so it must be right then).
        chosenVariantId = size.getAttribute('data-variant-id');

        // Variant-aware gallery (replaces the Variant Image Wizard app): main image
        // becomes this variant's photo; the rail shows shared/lifestyle images plus
        // this variant's image (floated first), and hides images assigned to OTHER
        // variants — so the 6/12-pack shots never appear on the 3-pack, etc.
        var vId = size.getAttribute('data-variant-id');
        var vImg = size.getAttribute('data-variant-image');
        var galleryMain = root.querySelector('[data-gallery-main]');
        if (vImg && galleryMain) { showGalleryImage(); galleryMain.src = vImg; galleryMain.removeAttribute('srcset'); }
        var vThumbs = root.querySelectorAll('[data-gallery-thumb]');
        var vCountEl = root.querySelector('[data-gallery-count]');
        var vShown = 0, vActiveSet = false;
        vThumbs.forEach(function (t) {
          var ids = (t.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
          var mine = vImg && t.getAttribute('data-full') === vImg;
          var show = ids.length === 0 || ids.indexOf(vId) !== -1;   // shared, or this variant's
          t.hidden = !show;
          t.style.order = mine ? '-1' : '';   // this variant's image leads the rail
          t.classList.toggle('gmpdp-thumb--active', !!mine);
          if (mine) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
          if (mine && galleryMain && t.getAttribute('data-alt')) galleryMain.alt = t.getAttribute('data-alt');
          if (show) { vShown++; if (mine) vActiveSet = true; }
        });
        if (!vActiveSet) {
          var firstVis = [].slice.call(vThumbs).filter(function (t) { return !t.hidden; })[0];
          if (firstVis) { firstVis.classList.add('gmpdp-thumb--active'); firstVis.setAttribute('aria-current', 'true'); }
        }
        if (vCountEl) vCountEl.textContent = '1 / ' + vShown;

        // mode → drive Seal's hidden radios (Seal owns the selling_plan input when
        // it is present), then guarantee a selling_plan exists either way.
        var m = currentMode();
        applySealMode(m);
        syncSellingPlan(m);

        // button — when the selected pack is out of stock the label carries that, and the
        // price/arrow are hidden rather than advertising a purchase that cannot complete.
        var price = (m === 'subscribe' && sub) ? sub : oneTime;
        if (addLabel) addLabel.textContent = available ? addLabelFor(count) : soldOutLabel;
        if (addPrice) { addPrice.innerHTML = '&mdash; ' + price; addPrice.hidden = !available; }
        if (addArrow) { addArrow.hidden = !available; if (available) addArrow.setAttribute('aria-hidden', 'true'); else addArrow.removeAttribute('aria-hidden'); }
        if (soldNote) soldNote.hidden = available;
        if (addBtn) {
          addBtn.disabled = !available;
          addBtn.classList.toggle('is-disabled', !available);
        }

        // sticky bar tracks the same selection
        if (stickyPack) stickyPack.textContent = count + '-pack';
        if (stickyLabel) stickyLabel.textContent = available ? addLabelFor(count) : soldOutLabel;
        if (stickyPrice) { stickyPrice.innerHTML = '&mdash; ' + price; stickyPrice.hidden = !available; }
        if (stickyArrow) { stickyArrow.hidden = !available; if (available) stickyArrow.setAttribute('aria-hidden', 'true'); else stickyArrow.removeAttribute('aria-hidden'); }
        if (stickyMode) {
          stickyMode.textContent = (m === 'subscribe' && subBadge)
            ? subBadge.textContent.trim()
            : 'One-time';
        }
        if (stickyBtn) {
          stickyBtn.disabled = !available;
          stickyBtn.classList.toggle('is-disabled', !available);
        }
      }

      // BL-1: the pack radios are now real, focusable controls. Drive selection
      // from the radio's `change` event so it fires for mouse (native label
      // association), keyboard arrow-key navigation and AT alike.
      sizes.forEach(function (size) {
        var input = size.querySelector('input[type="radio"]');
        function selectSize() {
          if (size.getAttribute('data-available') !== 'true') return;
          sizes.forEach(function (x) { x.classList.remove('gmpdp-size--selected'); });
          size.classList.add('gmpdp-size--selected');
          if (input) input.checked = true;
          refresh();
        }
        if (input) input.addEventListener('change', selectSize);
      });

      // BL-2: purchase-mode radios are real, focusable controls. Drive state from
      // the radio's `change` event so keyboard and AT users can reach Subscribe.
      modeOpts.forEach(function (opt) {
        var input = opt.querySelector('input[type="radio"]');
        function selectMode() {
          mode = opt.getAttribute('data-mode');
          modeOpts.forEach(function (x) { x.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          if (input) input.checked = true;
          refresh();
        }
        if (input) input.addEventListener('change', selectMode);
      });

      // gallery thumb swap
      var mainImg = root.querySelector('[data-gallery-main]');
      var count = root.querySelector('[data-gallery-count]');
      var total = root.querySelectorAll('[data-gallery-thumb]').length;
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          // Count by VISUAL order, not DOM order — the current variant's thumb is
          // floated to the front with CSS `order:-1`, so a plain DOM index would be
          // off by that offset (the "2nd image thinks it's 1st" bug).
          var vis = [].slice.call(root.querySelectorAll('[data-gallery-thumb]'))
            .filter(function (t) { return !t.hidden; })
            .sort(function (a, b) { return (parseInt(getComputedStyle(a).order, 10) || 0) - (parseInt(getComputedStyle(b).order, 10) || 0); });
          root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('gmpdp-thumb--active'); t.removeAttribute('aria-current'); });
          thumb.classList.add('gmpdp-thumb--active');
          thumb.setAttribute('aria-current', 'true');
          if (thumb.getAttribute('data-media-type') === 'video' && showGalleryVideo(thumb.getAttribute('data-gallery-thumb'), thumb.getAttribute('data-video-alt'))) {
            // video shown in place of the hero
          } else {
            showGalleryImage();
            if (mainImg) { mainImg.src = thumb.getAttribute('data-full'); mainImg.removeAttribute('srcset'); mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt; }
          }
          if (count) count.textContent = (vis.indexOf(thumb) + 1) + ' / ' + vis.length;
        });
      });

      // Touch swipe on the hero steps to the next/previous visible thumbnail by clicking it, so one code path
      // updates the image, alt, count and aria-current. The thumbnail row remains the non-gesture way to do this.
      var heroBox = root.querySelector('.gmpdp-gallery__main');
      if (heroBox) {
        var swipeX = null, swipeY = null;
        heroBox.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { swipeX = null; return; }
          swipeX = e.touches[0].clientX; swipeY = e.touches[0].clientY;
        }, { passive: true });
        heroBox.addEventListener('touchend', function (e) {
          if (swipeX === null) return;
          var dx = e.changedTouches[0].clientX - swipeX, dy = e.changedTouches[0].clientY - swipeY;
          swipeX = null;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          var vis = [].slice.call(root.querySelectorAll('[data-gallery-thumb]'))
            .filter(function (t) { return !t.hidden; })
            .sort(function (a, b) { return (parseInt(getComputedStyle(a).order, 10) || 0) - (parseInt(getComputedStyle(b).order, 10) || 0); });
          var at = vis.findIndex(function (t) { return t.classList.contains('gmpdp-thumb--active'); });
          var next = vis[at + (dx < 0 ? 1 : -1)];
          if (next) {
            next.click();
            if (next.scrollIntoView) next.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }, { passive: true });
      }

      // Subscribe-note tooltip: it reveals on hover/focus via CSS. WCAG 1.4.13
      // wants a way to dismiss it without moving the pointer or focus, so Escape
      // suppresses it (via a class) while keeping focus put; leaving or re-entering
      // clears the class so it can show again.
      var infoTip = root.querySelector('.gmpdp-info');
      if (infoTip) {
        infoTip.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' || e.key === 'Esc') infoTip.classList.add('gmpdp-info--hidetip');
        });
        infoTip.addEventListener('blur', function () { infoTip.classList.remove('gmpdp-info--hidetip'); });
        infoTip.addEventListener('mouseleave', function () { infoTip.classList.remove('gmpdp-info--hidetip'); });
      }

      // ---- CART DRAWER (AJAX add-to-cart) --------------------------------
      // Motion already owns this whole flow; we just opt our form into it:
      //   theme.AjaxProduct  → intercepts submit, POSTs theme.routes.cartAdd,
      //                        then dispatches `ajaxProduct:added` on the form.
      //   theme.CartDrawer   → listens for that event on `document`, rebuilds the
      //                        cart and opens the drawer. Already initialised when
      //                        the cart_type setting is "drawer" (it is).
      // So one instantiation replaces the native POST → /cart page load, and the
      // drawer opens for free. Motion also handles the button loading state and
      // renders sold-out / error responses into `.errors` inside the form.
      //
      // ⚠️ The sticky bar's button submits THIS form via `form="…"`, so it goes
      // through the same interception — no separate wiring, and no second listener.
      //
      // ⚠️ TIMING — this must wait for DOMContentLoaded, and the reason is not obvious.
      // A section's javascript block compiles into `scripts.js`, which the layout loads
      // BEFORE `theme.js` (measured in the served HTML: scripts.js #7, theme.js #10,
      // both `defer`). Deferred scripts run in document order, so at the moment this
      // IIFE executes `theme.AjaxProduct` does not exist yet. Instantiating here
      // silently did nothing and the form kept doing a native POST to /cart.
      //
      // Note `readyState` is already "interactive" when a deferred script runs — it is
      // never "loading" — so the usual `readyState === 'loading'` guard would take the
      // immediate branch and fail the same way. Only "complete" means we missed the event.
      //
      // Falls back gracefully: if theme.AjaxProduct is genuinely absent, nothing is
      // attached and the form does what it always did — a native POST to /cart.
      // Seal loads asynchronously, so it can inject its widget AFTER our last
      // refresh() — at which point our fallback input and Seal's would both exist.
      // Re-sync on submit, in the CAPTURE phase on `document` so it runs before
      // Motion's bubble-phase listener on the form serializes it.
      document.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        syncSellingPlan(currentMode());
        // Show the form the CHOSEN pack for the duration of this submit only. Every reader (Elevar's
        // add_to_cart listener, Motion's serialize, native submit) reads it synchronously inside this
        // event; the timeout restores the pin after all of them, so Elevar's 500 ms poll never sees
        // the chosen pack and dl_view_item stays at one per page load.
        if (variantInput && chosenVariantId) {
          variantInput.value = chosenVariantId;
          setTimeout(function () { variantInput.value = pinnedVariantId; }, 0);
        }
      }, true);

      function initAjaxCart() {
        if (window.theme && theme.AjaxProduct) {
          new theme.AjaxProduct(form, '[data-add-btn]');
        }
      }
      if (document.readyState === 'complete') {
        initAjaxCart();
      } else {
        document.addEventListener('DOMContentLoaded', initAjaxCart);
      }

      // Sticky bar reveal. Default is "after" — the bar appears only once the real
      // add-to-cart button has scrolled out of view, so two identical CTAs are never
      // on screen at once (which reads as a rendering bug). "always" matches the
      // comp literally. Either way the body gets bottom padding while it's up, so
      // the bar can't sit on top of the footer.
      if (sticky && addBtn) {
        var behavior = sticky.getAttribute('data-sticky-behavior');
        if (behavior === 'always') {
          document.body.classList.add('gmpdp-sticky-on');
        } else if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            var showing = !entries[0].isIntersecting;
            sticky.classList.toggle('is-visible', showing);
            document.body.classList.toggle('gmpdp-sticky-on', showing);
          }, { rootMargin: '0px 0px -80px 0px' }).observe(addBtn);
        } else {
          // No IO (very old browser): fail visible rather than hiding the CTA.
          sticky.classList.add('is-visible');
          document.body.classList.add('gmpdp-sticky-on');
        }
      }

      refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gourmend-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="gourmend-pdp-reviews"]').forEach(function (root) {
      var probe = root.querySelector('[data-rev-probe]');
      var scoreEl = root.querySelector('[data-rev-score]');
      var countEl = root.querySelector('[data-rev-count]');
      if (!probe || (!scoreEl && !countEl)) return;

      // HelpfulCrowd injects asynchronously and its markup is not contractual, so
      // read the numbers out of the probe's TEXT rather than depending on its
      // classes. Expected shape is roughly "4.8 · 405 reviews" / "4.8 (405)".
      // Anything we can't parse confidently is left alone — the curated setting
      // value is a better fallback than a wrong number.
      function patch() {
        var txt = (probe.textContent || '').replace(/\s+/g, ' ').trim();
        if (!txt) return false;

        // Score: first number 0–5 with an optional decimal.
        var score = txt.match(/\b([0-5](?:\.\d)?)\b/);
        // Count: first integer of 2+ digits, or one followed by "review(s)".
        var count = txt.match(/([\d,]+)\s*reviews?/i) || txt.match(/\b(\d{2,}(?:,\d{3})*)\b/);

        var did = false;
        if (score && scoreEl) { scoreEl.textContent = score[1]; did = true; }
        if (count && countEl) {
          countEl.textContent = count[1];
          // Keep a count inside the CTA label honest too, if one is there.
          var cta = root.querySelector('.gmrev__cta');
          if (cta) {
            cta.innerHTML = cta.innerHTML.replace(/[\d,]{2,}/, count[1]);
          }
          did = true;
        }
        return did;
      }

      // ---- LIVE DISTRIBUTION BARS ----------------------------------------
      // HelpfulCrowd's `product-tabs` widget renders the REAL per-star breakdown as
      // `.hc-rating-chart__row` > `.hc-rating-chart__percentage-value`. Verified
      // 2026-07-29: the curated settings said 82/13/3/1/1 while the true figures are
      // 88.9 / 6.2 / 3.0 / 1.0 / 1.0 — i.e. the hand-maintained numbers were wrong.
      //
      // Rows carry no text star label (the rating column is glyphs), so DOM ORDER is
      // the only signal. It is 5★ → 1★, which matches our bars. Guards below mean a
      // change on their side degrades to the curated values rather than mislabelling:
      // we require exactly 5 rows and 5 parseable numbers, or we leave the bars alone.
      //
      // Depends on the feed being present — with `show_hc_feed` off there is no chart
      // to read, and the settings stand.
      function patchBars() {
        var bars = root.querySelectorAll('[data-rev-bar]');
        if (bars.length !== 5) return false;
        var rows = document.querySelectorAll('.hc-rating-chart__row');
        if (rows.length !== 5) return false;

        var vals = [];
        for (var i = 0; i < rows.length; i++) {
          var cell = rows[i].querySelector('.hc-rating-chart__percentage-value');
          var n = cell ? parseFloat((cell.textContent || '').replace('%', '').trim()) : NaN;
          if (isNaN(n) || n < 0 || n > 100) return false;
          vals.push(n);
        }

        for (var j = 0; j < 5; j++) {
          var pct = Math.round(vals[j]);
          var fill = bars[j].querySelector('[data-rev-bar-fill]');
          var label = bars[j].querySelector('[data-rev-bar-pct]');
          if (fill) fill.style.width = pct + '%';
          if (label) label.textContent = pct + '%';
        }
        return true;
      }

      var barsDone = false;
      var numbersDone = patch();
      barsDone = patchBars();
      if (numbersDone && barsDone) return;

      // Two independent HC injections to wait on: the rating probe (score/count) and
      // the tabs widget (distribution chart). They land at different times, so watch
      // both and only stop once each has been applied.
      var obs = new MutationObserver(function () {
        if (!numbersDone) numbersDone = patch();
        if (!barsDone) barsDone = patchBars();
        if (numbersDone && barsDone) obs.disconnect();
      });
      obs.observe(probe, { childList: true, subtree: true, characterData: true });
      var feed = root.querySelector('.gmrev__feed');
      if (feed) obs.observe(feed, { childList: true, subtree: true });

      // HC may never load (blocked, no reviews yet) — stop watching rather than
      // leaving an observer attached for the life of the page.
      setTimeout(function () { obs.disconnect(); }, 10000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
